<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1>FAQ</h1>
            <!-- <ul>
                <li>
                    <a href="index.html">home</a>
                </li>
                <li>&gt;</li>
                <li>FAQ</li>
            </ul> -->
        </div>
    </div>
</div>

<div class="el-blog-single-wrapper pt-1">
    <div class="container">
        <div class="row gy-4">



            <div class="col-lg-12 col-md-12">

                <div class="el-inner-blog-box el-blogsingle-comment-box el-blgs-comments-wrapper">
                    <!-- <div class="el-comment-title">
                        <h4 class="el-blog-title">FAQ</h4>
                    </div> -->

                    <div class="accordion accordion-flush" id="faq">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="faq-headingOne">
                                <button class="accordion-button " type="button" data-bs-toggle="collapse"
                                    data-bs-target="#faq-collapseOne" aria-expanded="true"
                                    aria-controls="faq-collapseOne">
                                    What makes Power Prep mock tests the ideal prep tool?
                                </button>
                            </h2>
                            <div id="faq-collapseOne" class="accordion-collapse collapse show"
                                aria-labelledby="faq-headingOne" data-bs-parent="#faq">
                                <div class="accordion-body">Each mock test at Power Prep is carefully prepared to look
                                    like the actual Olympiad exam. It follows the same level,
                                    time limit, and question format, helping students get used to the exam and feel more
                                    confident before the actual test.
                                    Wherein along with the comprehensive study material, it offers students more
                                    in-depth preparation and conceptual
                                    clarity.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="faq-headingTwo">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#faq-collapseTwo" aria-expanded="false"
                                    aria-controls="faq-collapseTwo">
                                    Will I get reports after each mock test?
                                </button>
                            </h2>
                            <div id="faq-collapseTwo" class="accordion-collapse collapse"
                                aria-labelledby="faq-headingTwo" data-bs-parent="#faq">
                                <div class="accordion-body">Yes, you’ll receive your detailed reports. This will help
                                    you quickly identify areas that need more focus and track your
                                    improvement.
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="faq-headingThree">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#faq-collapseThree" aria-expanded="false"
                                    aria-controls="faq-collapseThree">
                                    How do mock tests help me stay ahead of the competition?
                                </button>
                            </h2>
                            <div id="faq-collapseThree" class="accordion-collapse collapse"
                                aria-labelledby="faq-headingThree" data-bs-parent="#faq">
                                <div class="accordion-body">
                                    <p class="el-para">These mock tests help students prepare effectively for their
                                        exams.
                                        Focusing on skills such as:
                                    </p>
                                    <ul style="list-style-type: disc;">
                                        <li>Real-time exam simulation</li>
                                        <li>Improved time management
                                        </li>
                                        <li>Exposure to diverse questions
                                        </li>
                                        <li>Insight into your strengths and weaknesses
                                        </li>
                                    </ul>
                                    <p class="el-para">This helps you approach the actual Olympiad with confidence and
                                        clarity.

                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="faq-headingFour">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#faq-collapseFour" aria-expanded="false"
                                    aria-controls="faq-collapseFour">
                                    Is there a fee to access the mock test series?
                                </button>
                            </h2>
                            <div id="faq-collapseFour" class="accordion-collapse collapse"
                                aria-labelledby="faq-headingFour" data-bs-parent="#faq">
                                <div class="accordion-body">
                                    <p class="el-para">Yes. Various plans are available to access the Power Prep mock
                                        test series. Each plan includes subjective mock tests
                                        along with comprehensive study materials, giving full access to features such as
                                        expert-designed questions, real-time
                                        practice, progress tracking, and more, all aimed at boosting students’
                                        confidence.
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="faq-headingFive">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#faq-collapseFive" aria-expanded="false"
                                    aria-controls="faq-collapseFive">
                                    Can I practise subject-wise?
                                </button>
                            </h2>
                            <div id="faq-collapseFive" class="accordion-collapse collapse"
                                aria-labelledby="faq-headingFive" data-bs-parent="#faq">
                                <div class="accordion-body">
                                    <p class="el-para">Yes, you can choose mock tests including Maths, English, and
                                        Science, for grades 3 to 8.
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="faq-headingSix">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#faq-collapseSix" aria-expanded="false"
                                    aria-controls="faq-collapseSix">
                                    Do mock tests at Power Prep align with the Olympiad Syllabus?

                                </button>
                            </h2>
                            <div id="faq-collapseSix" class="accordion-collapse collapse"
                                aria-labelledby="faq-headingSix" data-bs-parent="#faq">
                                <div class="accordion-body">
                                    <p class="el-para">Yes, mock tests at Power Prep align with the Olympiad syllabus.
                                        Focused on the format, considering difficulty level with
                                        the same structure as the actual exam.
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="faq-headingSeven">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#faq-collapseSeven" aria-expanded="false"
                                    aria-controls="faq-collapseSeven">
                                    Are the mock tests updated regularly?
                                </button>
                            </h2>
                            <div id="faq-collapseSeven" class="accordion-collapse collapse"
                                aria-labelledby="faq-headingSeven" data-bs-parent="#faq">
                                <div class="accordion-body">
                                    <p class="el-para">Yes, the question sets in the mock tests are regularly reviewed
                                        and updated as per the latest updates and requirements
                                        for educational rules and regulations and the syllabus.
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="faq-headingEight">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#faq-collapseEight" aria-expanded="false"
                                    aria-controls="faq-collapseEight">
                                    Do all plans include a free mock test?
                                </button>
                            </h2>
                            <div id="faq-collapseEight" class="accordion-collapse collapse"
                                aria-labelledby="faq-headingEight" data-bs-parent="#faq">
                                <div class="accordion-body">
                                    <p class="el-para">Yes. All plans begin with 1 free mock test to give you a preview
                                        of the platform and format.
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="faq-headingNine">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#faq-collapseNine" aria-expanded="false"
                                    aria-controls="faq-collapseNine">
                                    When are the mock tests scheduled?
                                </button>
                            </h2>
                            <div id="faq-collapseNine" class="accordion-collapse collapse"
                                aria-labelledby="faq-headingNine" data-bs-parent="#faq">
                                <div class="accordion-body">
                                    <p class="el-para">Power Prep mock tests are conducted at regular intervals
                                        throughout the academic year, ensuring students get timely
                                        practice and preparation ahead of the Olympiads.
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="faq-headingTen">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#faq-collapseTen" aria-expanded="false"
                                    aria-controls="faq-collapseTen">
                                    How can I improve my Olympiad preparation?
                                </button>
                            </h2>
                            <div id="faq-collapseTen" class="accordion-collapse collapse"
                                aria-labelledby="faq-headingTen" data-bs-parent="#faq">
                                <div class="accordion-body">
                                    <p class="el-para">With the help of Power Prep Mock Tests, you can enhance your
                                        Olympiad preparation. In these mock tests, you can access
                                        comprehensive study materials, making your study strategy more effective.
                                        Offering the chance to focus on how you can
                                        solve questions quickly, understand tricky topics better, manage time, focus on
                                        core concepts and more, and with this,
                                        you can efficiently improve your preparation with Power Prep Mock Test.
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="faq-headingEleven">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#faq-collapseEleven" aria-expanded="false"
                                    aria-controls="faq-collapseEleven">
                                    Are these mock test questions like the real Olympiad exam?
                                </button>
                            </h2>
                            <div id="faq-collapseEleven" class="accordion-collapse collapse"
                                aria-labelledby="faq-headingEleven" data-bs-parent="#faq">
                                <div class="accordion-body">
                                    <p class="el-para">Yes, the mock test questions are prepared by experts following
                                        the same pattern as the real Olympiad exams. With this,
                                        you can efficiently prepare and become familiar with the types of questions you
                                        will encounter in your Olympiad hour.
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="accordion-item">
                            <h2 class="accordion-header" id="faq-headingTwelve">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#faq-collapseTwelve" aria-expanded="false"
                                    aria-controls="faq-collapseTwelve">
                                    Will these tests help even if I’m already doing well in school?
                                </button>
                            </h2>
                            <div id="faq-collapseTwelve" class="accordion-collapse collapse"
                                aria-labelledby="faq-headingTwelve" data-bs-parent="#faq">
                                <div class="accordion-body">
                                    <p class="el-para">Yes. Even if you are already performing well academically, Power
                                        Prep Mock Tests can further enhance your performance,
                                        making your preparation more efficient and effective for the Olympiads. Power
                                        Prep also boosts your confidence by
                                        offering extra challenges and smart practice routes, helping you stay ahead in
                                        the competition.

                                    </p>

                                </div>
                            </div>
                        </div>

                    </div>




















                    <!-- <div class="el-blgs-comments">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>What makes Power Prep mock tests the ideal prep tool?
                                </h5>

                            </div>
                            <p class="el-para">Each mock test at Power Prep is carefully prepared to look like the
                                actual Olympiad exam. It follows the same level,
                                time limit, and question format, helping students get used to the exam and feel more
                                confident before the actual test.
                                Wherein along with the comprehensive study material, it offers students better in-depth
                                preparation and conceptual
                                clarity.</p>

                        </div>
                    </div>
                    <div class="el-blgs-comments ">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>Will I get reports after each mock test?
                                </h5>

                            </div>
                            <p class="el-para">Yes, you’ll receive your detailed reports. This will help you quickly
                                identify areas that need more focus and track your
                                improvement.
                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments ms-0">

                        <div class="el-blgs-cmts ">
                            <div class="el-blgs-cmt-name">
                                <h5>How do mock tests help me stay ahead of the competition?
                                </h5>

                            </div>
                            <p class="el-para">These mock tests help students prepare effectively for their exams.
                                Focusing on skills such as:
                            </p>
                            <ul>
                                <li>Real-time exam simulation</li>
                                <li>Improved time management
                                </li>
                                <li>Exposure to diverse questions
                                </li>
                                <li>Insight into your strengths and weaknesses
                                </li>
                            </ul>
                            <p class="el-para">This helps you approach the actual Olympiad with confidence and clarity.

                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments ms-0">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>Is there a fee to access the mock test series?
                                </h5>

                            </div>
                            <p class="el-para">Yes, various plans are available to access the Power Prep mock test
                                series. This plan will include subjective mock tests,
                                along with comprehensive study materials, providing full access to features such as
                                expert-designed questions, real-time
                                practice, progress tracking, and more, with the aim of boosting their confidence.
                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>Can I practise subject-wise?

                                </h5>

                            </div>
                            <p class="el-para">Yes, you can choose mock tests including Maths, English, and Science, for
                                grades 3 to 8.

                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>Do mock tests align with the Power Prep Olympiad syllabus?

                                </h5>

                            </div>
                            <p class="el-para">Yes, mock tests at Power Prep align with the Olympiad syllabus. Focused
                                on the format, considering difficulty level with
                                the same structure as the actual exam.

                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>Are the mock tests updated regularly?


                                </h5>

                            </div>
                            <p class="el-para">Yes, the question sets in the mock tests are regularly reviewed and
                                updated as per the latest updates and requirements
                                for educational rules and regulations and the syllabus.


                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>Do all plans include a free mock test?


                                </h5>

                            </div>
                            <p class="el-para">Yes. All plans begin with 1 free mock test to give you a preview of the
                                platform and format.


                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>When are the mock tests scheduled?


                                </h5>

                            </div>

                            <p class="el-para">All Power Prep mock tests are scheduled at regular intervals, allowing
                                students to check their progress and strengthen
                                their preparation ahead of the Olympiads. Here's the complete mock test timeline:


                            </p>

                            <ul>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                            </ul>

                        </div>
                    </div>
                    <div class="el-blgs-comments">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>How can I improve my Olympiad preparation?


                                </h5>

                            </div>
                            <p class="el-para">With the help of <b>Power Prep Mock Tests</b>, you can enhance your
                                Olympiad preparation. In these mock tests, you can access
                                comprehensive study materials, making your study strategy more effective. Offering the
                                chance to focus on how you can
                                solve questions quickly, understand tricky topics better, manage time, focus on core
                                concepts and more, and with this,
                                you can efficiently improve your preparation with Power Prep Mock Test.


                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>Are these mock test questions like the real Olympiad exam?



                                </h5>

                            </div>
                            <p class="el-para">Yes, the mock test questions are prepared by experts following the same
                                pattern as the real Olympiad exams. With this,
                                you can efficiently prepare and become familiar with the types of questions you will
                                encounter in your Olympiad hour.



                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>Will these tests help even if I’m already doing well in school?



                                </h5>

                            </div>
                            <p class="el-para">Yes! Even if you are doing good, still with Power Prep mock tests, it
                                will help you in making your performance much
                                better and efficient than before. Focusing on attaining



                            </p>

                        </div>
                    </div> -->
                </div>

            </div>
            <!-- <div class="col-lg-3 col-md-12">
                <div class="el-blog-sidebar-main">
                    <div class="el-inner-blog-box el-search-widget">
                        <h4 class="el-blog-title">search</h4>
                        <div class="el-input-field">
                            <input type="text" placeholder="Your Email">
                            <a href="javascript:;" class="el-btn">
                                <img src="../assets/images/all-instructor/search-white.svg" alt="Right Arrow">
                            </a>
                        </div>
                    </div>
                    <div class="el-inner-blog-box el-category-widget">
                        <h4 class="el-blog-title">search Categories</h4>
                        <ul>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    School Psychology
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    Youth Counseling
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    Exam Stress
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    Our Experise
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    Vocational Counseling
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    Student Guidance
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="el-inner-blog-box el-category-widget">
                        <h4 class="el-blog-title">our archive</h4>
                        <ul>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    january 2023 (4)
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    february 2024 (1)
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    march 2023 (13)
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    december 2023 (5)
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="el-inner-blog-box el-tags-widget">
                        <h4 class="el-blog-title">search by tags</h4>
                        <div class="el-blog-tags">
                            <a href="javascript:;" class="el-btn">university</a>
                            <a href="javascript:;" class="el-btn">skills</a>
                            <a href="javascript:;" class="el-btn">tests</a>
                            <a href="javascript:;" class="el-btn">exams</a>
                            <a href="javascript:;" class="el-btn">courses</a>
                            <a href="javascript:;" class="el-btn">college</a>
                            <a href="javascript:;" class="el-btn">elementary school</a>
                            <a href="javascript:;" class="el-btn">education</a>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>